

<button mat-flat-button color="accent" (click)="addEmail()">+ Dodaj
    email</button>
<div class="row">
    <div class="col">
        <h3>Lista adresów Email</h3>
        <div fxLayoutAlign="center center">
            <mat-form-field fxFlex="40%" appearance="outline">
                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtruj">
            </mat-form-field>
        </div>

        <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th style="width:50px;" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ADRES EMAIL</th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- IP Column -->
            <ng-container matColumnDef="report">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>RAPORT</th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon *ngIf="element.report" aria-hidden="false" aria-label="Enabled"
                        fontIcon="check_circle_outline" class="material-icons color_green"></mat-icon>
                    <mat-icon *ngIf="!element.report" aria-hidden="false" aria-label="Disabled"
                        fontIcon="block" class="material-icons color_red"></mat-icon>
                </td>
            </ng-container>

            <!-- IP Column -->
            <ng-container matColumnDef="error">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ERROR</th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon *ngIf="element.error" aria-hidden="false" aria-label="Enabled"
                        fontIcon="check_circle_outline" class="material-icons color_green"></mat-icon>
                    <mat-icon *ngIf="!element.error" aria-hidden="false" aria-label="Disabled"
                        fontIcon="block" class="material-icons color_red"></mat-icon>
                </td>
            </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="alert">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ALERT</th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon *ngIf="element.alert" aria-hidden="false" aria-label="Enabled"
                        fontIcon="check_circle_outline" class="material-icons color_green"></mat-icon>
                    <mat-icon *ngIf="!element.alert" aria-hidden="false" aria-label="Disabled"
                        fontIcon="block" class="material-icons color_red"></mat-icon>
                </td>
            </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>AKCJE</th>
                <td mat-cell *matCellDef="let element">
                    <button type="button" class="btn btn-primary btn-action"
                        (click)="editElement(element)"><mat-icon aria-hidden="false" aria-label="Edytuj"
                            fontIcon="edit"></mat-icon></button>
                    <button type="button" class="btn btn-danger btn-action"
                        (click)="deleteElement(element)"><mat-icon aria-hidden="false" aria-label="Usuń"
                            fontIcon="delete"></mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>
        <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
        </mat-paginator>
    </div>
</div>